import { Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-observation-box',
  templateUrl: './observation-box.component.html',
  styleUrls: ['./observation-box.component.css'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ObservationBoxComponent),
      multi: true
    }
  ]
})

export class ObservationBoxComponent implements ControlValueAccessor {

  value: string;
  disabled: boolean;
  @Input() label: string;
  onChange: any = () => { };
  onTouched: any = () => { };

  writeValue(newValue: string): void {
    this.value = newValue ? newValue : '';
  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

}
